import React, { useState } from "react";
import { CgMenuOreos } from "react-icons/cg";
import { GiShoppingBag } from "react-icons/gi";
import { IoLogOut } from "react-icons/io5";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const showMenuFun = () => {
    setShowMenu((showMenu) => !showMenu);
    console.log(showMenu);
  };
  return (
    <div>
      <div className="navbar">
        <nav className="menu">
          <li>Pencil Drawing</li>
          <li>Color Pencil Drawing</li>
          <li>Texture Art</li>
          <li>Resin Art</li>
        </nav>
        <h2 className="mobileHead">Canvas</h2>
        <nav className="logout">
          <CgMenuOreos
            className="menuicon"
            id="menu"
            onClick={showMenuFun}
          />
          <GiShoppingBag
          className="cart"/>
          <IoLogOut className="logoutBtn" />
        </nav>
      </div>

      {showMenu && (
        <div className="mobileNavbar">
          <li>Pencil Drawing</li>
          <li>Color Pencil Drawing</li>
          <li>Texture Art</li>
          <li>Resin Art</li>
        </div>
      )}
    </div>
  );
};

export default Navbar;
